var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDocumentation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.16669 3.32783C2.16669 2.87063 2.54611 2.5 2.99319 2.5H18.0069C18.4634 2.5 18.8334 2.87079 18.8334 3.32783V16.6722C18.8334 17.1293 18.4539 17.5 18.0069 17.5H2.99319C2.53673 17.5 2.16669 17.1292 2.16669 16.6722V3.32783ZM9.66669 4.16667H3.83335V15.8333H9.66669V4.16667ZM11.3334 4.16667V15.8333H17.1667V4.16667H11.3334ZM12.1667 5.83333H16.3334V7.5H12.1667V5.83333ZM12.1667 8.33333H16.3334V10H12.1667V8.33333Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocumentation);
export default __webpack_public_path__ + "static/media/documentation.380c4a325dbb1732758c2fb7a7f3bfb8.svg";
export { ForwardRef as ReactComponent };